import { Trash2Icon } from 'lucide-react'

import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
  Link,
  TruncatedText,
} from '@/components/ui'
import type { CellContext } from '@/components/ui/table/types'
import {
  DeleteStatementsDialog,
  ProcessButton,
  type Statement,
} from '@/modules/projects'
import {
  hasStatementFailed,
  isStatementProcessing,
} from '@/modules/projects/status'
import { useDialogActions } from '@/stores/dialog'

export const DocumentCell = (cell: CellContext<Statement, string>) => {
  const { openDialog } = useDialogActions()
  const statement = cell.row.original
  const fileName = cell.getValue()
  const fileUrl = statement.fileUrl
  const isProcessing = isStatementProcessing(statement)

  if (fileUrl) {
    return (
      <ContextMenu>
        <ContextMenuTrigger asChild>
          <Link
            href={fileUrl}
            className="block min-w-0 text-sm"
            newTab
            onClick={(event) => event.stopPropagation()}
          >
            <TruncatedText text={fileName} />
          </Link>
        </ContextMenuTrigger>
        <ContextMenuContent>
          <ContextMenuItem asChild>
            <ProcessButton
              theme="ghost"
              table={cell.table}
              statementsToProcess={[statement]}
              validationBehaviour="disable-only"
            >
              {hasStatementFailed(statement) ? 'Retry' : 'Process'} statement
            </ProcessButton>
          </ContextMenuItem>
          <ContextMenuSeparator />
          <ContextMenuItem
            onClick={() => openDialog(DeleteStatementsDialog.id, [statement])}
            destructive
            disabled={isProcessing}
          >
            <Trash2Icon className="h-4 w-4" />
            Delete statement
          </ContextMenuItem>
        </ContextMenuContent>
      </ContextMenu>
    )
  }

  return <TruncatedText text={fileName} className="text-sm" />
}
